// export function concatClass(a, b) {
//   if (a && a.indexOf(b) > -1) return a
//   return a ? (b ? a + ' ' + b : a) : b || ''
// }

function ipToLong(ip) {
  const parts = ip.split('.').map(Number)
  return (parts[0] << 24) | (parts[1] << 16) | (parts[2] << 8) | parts[3]
}

function countIpsBetween(ip1, ip2) {
  const longIp1 = ipToLong(ip1)
  const longIp2 = ipToLong(ip2)

  if (longIp1 > longIp2) {
    throw new Error('The first IP must be less than the second IP.')
  }

  return longIp2 - longIp1 - 1 // 不包括边界 IP
}

export function getIpBetweenCont(startIp, endIp) {
  var count = 0
  try {
    count = countIpsBetween(startIp, endIp)
    count = count + 2
  } catch (error) {
    console.log('ip 解析失败')
  }
  return count
}
